import { Config } from '@/config';
import { ApiService } from '@/services/api.service';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancelToken = null;

class OpportunityStatusesService {
  getOpportunityStatuses() {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.get(`${Config.api.document.url}api/v1/opportunity-statuses`, {
      cancelToken: cancelToken.token,
    }).then((response) => response.data);
  }
  addOpportunityStatus(opportunityStatus) {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.post(`${Config.api.document.url}api/v1/opportunity-statuses`, opportunityStatus, {
      cancelToken: cancelToken.token,
    }).then((response) => response.data);
  }
  editOpportunityStatus({ opportunityStatusId, opportunityStatus }) {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.put(
      `${Config.api.document.url}api/v1/opportunity-statuses/${opportunityStatusId}`,
      opportunityStatus,
      {
        cancelToken: cancelToken.token,
      },
    ).then((response) => response.data);
  }
  deleteOpportunityStatus(opportunityStatusId) {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.delete(`${Config.api.document.url}api/v1/opportunity-statuses/${opportunityStatusId}`, {
      cancelToken: cancelToken.token,
    }).then((response) => response.data);
  }
}

const opportunityStatusesService = new OpportunityStatusesService();

export default opportunityStatusesService;
